export default __webpack_public_path__ + "static/RHR-Logo-6d02ae4fc0172b2614d6dc1be16df4b7.svg";